import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EventViewModel } from '../../models-views/event.view.model';
import { BehaviorSubject, debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { CommonSenseEventService } from '../../services/commonsense-events.service';
import { AppCommon } from '../../providers/app-common';
import { QuickAddService } from '../../services/quick-add.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { defaultEventImage } from '../../appCommon';
import { DisabledTimeFn } from 'ng-zorro-antd/date-picker';
import { differenceInCalendarDays, setHours } from 'date-fns';
import { CurrencyPipe } from '@angular/common';
import { Router } from '@angular/router';
import { EventModeratorsService } from '../../services/event-moderators.service';
@Component({
  selector: 'app-event-drawer',
  standalone: false,
  templateUrl: './event-drawer.component.html',
  styleUrl: './event-drawer.component.scss',
  providers: [EventViewModel, CurrencyPipe]
})
export class EventDrawerComponent {
  defaultEventImage = defaultEventImage
  userSearchTimeOut:any
  managerSearchTimeOut:any
  @Input() isVisible = false;
  @Input() data :any;
  @Output() closeDrawer = new EventEmitter<boolean>();
  stepIndex = 0;
  countryList:any = [];
  stateList:any = [];
  cityList:any = [];
  eventForm: FormGroup;
  eventImage: File | null = null;
  destroy$ = new Subject();
  eventTypes = [];
  currencies = [];
  budgetType = [];
  statusList = [];
  eventFormats = [];
  eventImageUrl: string | ArrayBuffer | null = null;
  teamMembers:any = [];
  groups:any = [];
  loggedInUser :any
  loading:boolean = false
  listOfProject:any = []
  loadingProject:boolean = false
  searchInput$ = new Subject()
  disabledProject:boolean = false
  selectedEventTypeName: string = ''; // Cache the event type name from loaded data

  listOfIndustries:any = [];
  loadingIndustries:boolean = false;
  searchInputIndustry$ = new Subject();
  searchInputTimezone$ = new Subject<string>();

  loadingImage:boolean = false
  timezones:any = []
  loadingMsg =  new BehaviorSubject<string>('Loading form data...');
  stateClearTimeOut:any
  cityClearTimeOut:any

    // ── External Moderators ──────────────────────────────────────────────
    allModerators: any[] = [];
    moderatorModalVisible = false;
    moderatorSaving = false;
    editingModeratorForDrawer: any = null;

    get linkedModeratorIdsForDrawer(): number[] {
      return (this.eventForm?.get('event_moderators')?.value || []);
    }

  today = new Date();
  timeDefaultValue = setHours(new Date(), 0);
  // Half-day, Single-day, or Multi-day
  durationList = [
    {id: 1, name: 'Roundtable / Half-day'},
    {id: 2, name: 'Single-day'},
    {id: 3, name: 'Multi-day'}
  ]

  range(start: number, end: number): number[] {
    const result: number[] = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  }

  constructor(private fb: FormBuilder, private vm:EventViewModel, private quickAddService: QuickAddService, private cd: ChangeDetectorRef,
              private router: Router, private message: NzMessageService, private currency:CurrencyPipe,
              private moderatorService: EventModeratorsService) {

    this.vm.eventDrawerComponent = this;

    this.initForm();

    this.loggedInUser = AppCommon.getloggedInObject().user

    this.vm.countryList.pipe(takeUntil(this.destroy$)).subscribe( d =>
      this.countryList = d.results
    )
    this.vm.stateList.pipe(takeUntil(this.destroy$)).subscribe( d =>
      this.stateList = d.results
    )
    this.vm.cityList.pipe(takeUntil(this.destroy$)).subscribe( d =>
      this.cityList = d.results
    )

    this.vm.userList.pipe(takeUntil(this.destroy$)).subscribe( d =>
      this.teamMembers = d?.results
    )
    this.vm.userGroupList.pipe(takeUntil(this.destroy$)).subscribe( d => {
      // this.groups = d?.results
      this.groups = d?.results?.filter( v => v.is_event_ops === true )
    })

    this.vm.eventFormatType.pipe(takeUntil(this.destroy$)).subscribe( d => {
      this.eventFormats = d?.results;
      // After formats arrive, fetch event types according to current selection
      const currentFormatId = this.eventForm.get('event_format')?.value;
      if (currentFormatId != null) {
        this.loadEventTypesForFormatById(currentFormatId);
      }
  })

  this.vm.eventTypeList.pipe(takeUntil(this.destroy$)).subscribe( d => {
    this.eventTypes = d.results;
  })

    this.vm.currencyList.pipe(takeUntil(this.destroy$)).subscribe( d =>   this.currencies = d.results )

    this.vm.budgetTypeList.pipe(takeUntil(this.destroy$)).subscribe( d =>   this.budgetType = d.results )

    this.vm.statusTypeList.pipe(takeUntil(this.destroy$)).subscribe( d =>   this.statusList = d.results )

    this.vm.projectListData.subscribe(e => {
      const incoming = Array.isArray(e.results) ? e.results : [];
     
      // Merge incoming with existing to keep preloaded project
      const merged = [...this.listOfProject, ...incoming]
        .filter((p: any) => p && p.id)
        .reduce((acc: any[], curr: any) => {
          if (!acc.some((x: any) => x.id === curr.id)) {
            acc.push(curr);
          }
          return acc;
        }, []);
      this.listOfProject = merged;
      this.loadingProject = false;

      // If form already has a project id, ensure the control value stays set
      const currentProjectId = this.eventForm?.get('project')?.value;
      if (currentProjectId) {
        const found = this.listOfProject.find((p: any) => p.id === currentProjectId);
        if (found) {
          this.eventForm.get('project')?.setValue(found.id, { emitEvent: false });
        }
      }
    });
    this.vm.timezone.pipe(takeUntil(this.destroy$)).subscribe( d =>   this.timezones = d.results ?? [] )

    this.vm.industryList.subscribe( e =>( this.listOfIndustries = e.results , this.loadingIndustries = false));

    this.onBudgetChange()
    // this.onContryChange()
    // this.onStateChange()
    this.onEventUrlChange()

    this.searchInput$.pipe(debounceTime(500),distinctUntilChanged()).subscribe(
      (name:string) =>   this.vm.getProjectList(1,100,name))

    this.searchInputIndustry$.pipe(debounceTime(500),distinctUntilChanged()).subscribe((name: string) => this.vm.getIndustries(name))
    this.searchInputTimezone$.pipe(debounceTime(400), distinctUntilChanged()).subscribe((name: string) => {
      if (name.length === 0) {
        this.vm.getTimezoneList();
        return;
      }
      this.vm.getTimezoneList(name);
    })
  }

  // NEW: Add arrays for our custom time pickers
  timeHours: string[] = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
  timeMinutes: string[] = ['00', '15', '30', '45'];
  timeMeridiems: string[] = ['AM', 'PM'];

  // Cache event day rows per format to preserve values when switching modes
  private eventDaysCache: { [key: number]: any[] } = {};
  private currentFormatId: number | null = null; // retained for event type filtering
  private currentDurationId: number | null = null; // used for duration-driven day handling
  private initializedFromInputDays: boolean = false; // prevents ngOnInit from overriding edit values

  initForm() {
     this.eventForm = this.fb.group({
      event_name: ['',[Validators.required]],
      event_type: [null,[Validators.required]],
      city: [''],
      status: [1, [Validators.required]], // Default to 'Upcoming' (id: 1)
      // state: [''],
      // state: [''],
      country: [[], []],
      project:[ sessionStorage.getItem('selectedProject') ? Number(sessionStorage.getItem('selectedProject')) :  null],
      number_of_attendees: ['',[Validators.required, Validators.min(1), Validators.pattern(/^[0-9]+$/)]],
      budget_type: [null,[Validators.required]],
      budget_currency_type: [2,[Validators.required]],
      usd_currency_exchange_rate: [null],
      budget_currency_amount: [null],
      budget_amount: [{value: 0, disabled: true}],
      bec_event_planner: [[]],
      assigned_to: [[], [Validators.required]],
      assigned_group: [''],
      event_manager: [[]],
      event_url: [null],
      event_moderators: [[]],
      photo:[''],
      start_datetime: [null, [Validators.required]],
      end_datetime: [null, [Validators.required]],
      time_zone: [''],
      event_format: [1, [Validators.required]],
      industry: [[], []],
      duration: [1, [Validators.required]],
      duration_name: ['Half Day', []],
      // event_days: this.fb.array([this.createEventDayGroup()], [Validators.required])
      event_days: this.fb.array([this.createEventDayGroup()], [Validators.required])
    });
  }

  ngOnInit(): void {
    this.vm.getCountryList(1,300);
    // Do not load users by default for managers; they should populate only after Assigned Group is selected
    this.vm.getTimezoneList();
    this.vm.getUserGroupList(1,500);
    this.vm.getCurrencyList(1,500);
    this.vm.getBudgetTypeList(1,500);
    this.vm.getEventStatusList(1,500);
    // Do NOT load projects by default. Only search on user input.
    this.vm.getEventFormatList();
    // Do NOT load industries by default. Only search on user input.

    // Load all users by default for managers
    this.vm.getUserList(1, 500);

      // Load all external moderators for the drawer field
      this.loadAllModeratorsForDrawer();

    // When event type changes, cache its name
    this.eventForm.get('event_type')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((eventTypeId: number) => {
        if (eventTypeId && this.eventTypes && this.eventTypes.length > 0) {
          const selectedType = this.eventTypes.find(t => t.id === eventTypeId);
          if (selectedType?.name) {
            this.selectedEventTypeName = selectedType.name;
          }
        }
      });

    // Event format changes only affect event types list
    this.currentFormatId = this.eventForm.get('event_format')?.value ?? 1;
    this.eventForm.get('event_format').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((newFormat: number) => {
      if (newFormat != null) {
        // Reset event_type when format changes to load fresh types
        this.eventForm.get('event_type')?.setValue(null, { emitEvent: false });
        this.selectedEventTypeName = ''; // Clear cached name
        this.loadEventTypesForFormatById(newFormat);
      }
      this.currentFormatId = newFormat;
    });

    // Track current duration and react to changes with cache preservation and day enforcement
    this.currentDurationId = this.eventForm.get('duration')?.value ?? 1;
    this.eventForm.get('duration').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((newDuration: number) => {
      const prev = this.currentDurationId ?? newDuration;
      // Save current rows into cache for previous duration
      this.saveCurrentDaysToCache(prev);

      // Update duration_name based on selection
      this.eventForm.get('duration_name')?.setValue(this.getDurationNameById(newDuration), { emitEvent: false });

      // Restore rows for target duration if available, else set defaults
      this.restoreDaysFromCacheOrDefault(newDuration);

      // Inform user when switching to single-day/half-day reduces rows
      if ((newDuration === 1 || newDuration === 2) && this.event_days.length > 1) {
        this.message.info('Date selection has been reset to a single day.');
      }

      this.currentDurationId = newDuration;
      // Re-validate dates with new rules
      this.validateDates();
    });

    // Initialize duration_name; only enforce default rows when not already populated by input data
    this.eventForm.get('duration_name')?.setValue(this.getDurationNameById(this.currentDurationId), { emitEvent: false });
    if (!this.initializedFromInputDays) {
      this.restoreDaysFromCacheOrDefault(this.currentDurationId);
    }

    // Attach row-level watchers to existing default row(s)
    this.event_days.controls.forEach((ctrl: any) => this.attachEventDayWatchers(ctrl as FormGroup));
  }


  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.destroy$.next(true);
    this.destroy$.complete();
    // localStorage.removeItem('selectedProject');
  }

  ngOnChanges(changes: SimpleChanges): void {
        // Ensure the project from data.project_details is present in listOfProject for dropdown
        if (this.data && this.data.project_details) {
          const projectObj = this.data.project_details;
          if (projectObj.id && projectObj.name) {
            if (!Array.isArray(this.listOfProject)) {
              this.listOfProject = [];
            }
            const found = this.listOfProject.find((p: any) => p.id === projectObj.id);
            if (!found) {
              this.listOfProject = [...this.listOfProject, projectObj];
            }
            // Set the form control value so the dropdown displays the project
            this.eventForm.get('project')?.setValue(projectObj.id, { emitEvent: false });
            this.cd.detectChanges();
          }
        }
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.

    if(this.data && changes['data'].currentValue){
      // console.log("===============event data recived=========================",this.data)

      this.loading = true
      // this.vm.getStateListById(1,500,changes['data'].currentValue.country_id)
      this.vm.getStateListById(1,500,changes['data'].currentValue.city_country_id)


      
      // this.vm.getCityListById(1,500,changes['data'].currentValue.state_id)
      this.vm.getCityListById(1,500,changes['data'].currentValue.city_state_id)

      

      const selectedIndustryIds = Array.isArray(changes['data'].currentValue.industry)
        ? changes['data'].currentValue.industry
            .map((v: any) => (typeof v === 'object' ? v?.id : v))
            .filter((v: any) => v != null)
        : [];
      const selectedIndustryOptions = Array.isArray(changes['data'].currentValue.industry_details)
        ? changes['data'].currentValue.industry_details
            .filter((v: any) => v?.id != null && v?.name)
            .map((v: any) => ({ id: v.id, name: v.name }))
        : [];
      if (selectedIndustryOptions.length > 0) {
        const mergedIndustries = [...(this.listOfIndustries || []), ...selectedIndustryOptions]
          .filter((item: any, index: number, arr: any[]) =>
            item?.id != null && arr.findIndex((x: any) => x?.id === item.id) === index
          );
        this.listOfIndustries = mergedIndustries;
      }

      // Search timezone by name so the selected option appears in the dropdown
      const tzDetails = changes['data'].currentValue.time_zone_details;
      if (tzDetails?.name) {
        this.vm.getTimezoneList(tzDetails.name);
      }

      let formData = {
      event_name: changes['data'].currentValue.event_name,
      event_type: changes['data'].currentValue.event_type,
      project:changes['data'].currentValue?.project_details?.id,
      project_name:changes['data'].currentValue?.project_details?.name,
      number_of_attendees: changes['data'].currentValue.number_of_attendees,
      budget_type: changes['data'].currentValue.budget_type,
      budget_currency_type: changes['data'].currentValue.budget_currency_type,
      usd_currency_exchange_rate: changes['data'].currentValue.usd_currency_exchange_rate,
      budget_currency_amount: changes['data'].currentValue.budget_currency_amount,
      // budget_amount: changes['data'].currentValue.budget_amount,
      budget_amount: this.truncate(parseFloat(changes['data'].currentValue.budget_amount || '0'), 2),
      bec_event_planner: this.ensureArray(changes['data'].currentValue.bec_event_planner),
      assigned_to: this.ensureArray(changes['data'].currentValue.assigned_to),
      assigned_group: changes['data'].currentValue.assigned_group,
      event_manager: this.ensureArray(changes['data'].currentValue.event_manager),
      event_url: changes['data'].currentValue.event_url,
      event_moderators: this.ensureArray(changes['data'].currentValue.event_moderators)
        .map((v: any) => (typeof v === 'object' ? v?.id : v))
        .filter((v: any) => v != null),
      photo:changes['data'].currentValue.photo,
      status:changes['data'].currentValue.status,
      start_datetime:  new Date(changes['data'].currentValue.start_datetime),
      end_datetime: new Date(changes['data'].currentValue.end_datetime),
      city: changes['data'].currentValue.city,
      // state: changes['data'].currentValue.state_id,
      // state: changes['data'].currentValue.state_id,
      // country: changes['data'].currentValue.country_id,
      country: Array.isArray(changes['data'].currentValue.country_name)
      ? changes['data'].currentValue.country_name.map((c: any) => c.id)
      : [],
      time_zone: changes['data'].currentValue.time_zone,
      event_format: changes['data'].currentValue.event_format ? changes['data'].currentValue.event_format : 1,
      industry: selectedIndustryIds,
      duration: changes['data'].currentValue.duration ? changes['data'].currentValue.duration : 2
      }

      this.eventImageUrl = this.getBase64Image(changes['data'].currentValue.photo);

         // Always get the project list and assign matching project to the form
      this.loadingProject = true;
      this.vm.projectListData.subscribe(e => {
        this.listOfProject = Array.isArray(e.results) ? e.results : [];
        this.loadingProject = false;
        if (formData.project) {
          const found = this.listOfProject.find((p: any) => p.id === formData.project);
          if (found) {
            this.eventForm.get('project')?.setValue(found.id, { emitEvent: false });
          }
        }
      });

      // Cache the event type name from the loaded data
      if (changes['data'].currentValue.event_type_details?.name) {
        this.selectedEventTypeName = changes['data'].currentValue.event_type_details.name;
      }

      // NEW LOGIC for populating event_days on edit from timing array
      const timingArr = changes['data'].currentValue.timing;
  if (Array.isArray(timingArr) && timingArr.length > 0) {
        this.event_days.clear();
        const durationName = (changes['data'].currentValue.duration_name || '').toLowerCase();
        const fallbackDayType = durationName.includes('roundtable')
          ? 'roundtable'
          : (durationName.includes('half') ? 'half' : 'full');

        timingArr.forEach((t: any) => {
          if (!t?.start_time || !t?.end_time) return;
          const start = this.parseTimingToLocalDate(t.start_time);
          const end = this.parseTimingToLocalDate(t.end_time);
          if (!start || !end) return;
          const eventDate = new Date(start.getFullYear(), start.getMonth(), start.getDate());
          const group = this.createEventDayGroup();
          // Prefer per-item day_type if provided; else fallback from duration_name
          const tDayTypeRaw = (t.day_type ?? '').toString().toLowerCase();
          const resolvedDayType = ['full', 'half', 'roundtable'].includes(tDayTypeRaw) ? tDayTypeRaw : fallbackDayType;
          group.patchValue({
            event_date: eventDate,
            start_time: start,
            end_time: end,
            day_type: resolvedDayType
          });
          this.event_days.push(group);
          this.attachEventDayWatchers(group);
        });
        // mark initialized so ngOnInit doesn't overwrite
        this.initializedFromInputDays = true;
      } else {
        // fallback to legacy single-day if timing not present
        const startDateTime = changes['data'].currentValue.start_datetime;
        const endDateTime = changes['data'].currentValue.end_datetime;
        if (startDateTime && endDateTime) {
          this.event_days.clear();
          const dayGroup = this.createEventDayGroup();
          dayGroup.patchValue({
              event_date: new Date(startDateTime),
              start_time: new Date(startDateTime),
              end_time: new Date(endDateTime),
              day_type: 'full'
          });
          this.event_days.push(dayGroup);
          this.attachEventDayWatchers(dayGroup);
        }
      }

     setTimeout(() => {
        this.eventForm.patchValue(formData, { emitEvent: false });
        // console.log('[EventDrawer] eventForm after patchValue from parent data:', this.eventForm.value);
        // Ensure event types are loaded according to patched format
        if (formData.event_format != null) {
          this.loadEventTypesForFormatById(formData.event_format);
        }

        // Load users for the assigned group when editing - NO LONGER NEEDED as we load all users
        // if (formData.assigned_group) {
        //   this.vm.getUserList(1, 500, undefined, formData.assigned_group);
        // }

        // Compute duration from timing/event_days to keep consistency
        const computed = this.computeDurationFromEventDays();
        const durId = computed.id;
        const durName = computed.name;
        this.eventForm.get('duration')?.setValue(durId, { emitEvent: false });
        this.eventForm.get('duration_name')?.setValue(durName, { emitEvent: false });

        // Seed cache for the current duration with the populated rows
        this.currentDurationId = durId;
        this.saveCurrentDaysToCache(this.currentDurationId);
        this.loading = false
      } , 800)

    }

  }



  onBudgetChange() {
    this.eventForm.get('budget_type').valueChanges.subscribe( v => {
      if(v == 'FREE'){
        this.eventForm.get('budget_currency_type').setValue(2)
        this.eventForm.get('budget_amount').setValue(0)
        this.eventForm.get('budget_currency_amount').setValue(0)
        this.eventForm.get('usd_currency_exchange_rate').setValue(0)
      }
      // else {
        // this.eventForm.get('budget_currency_type').setValue(null)
        // this.eventForm.get('budget_amount').setValue(0)
      // }
    })
  }

  onSearchState(e:any){
    clearTimeout(this.stateClearTimeOut)
    this.stateClearTimeOut = setTimeout(() => {
    if(e.length > 0){
        this.vm.getStateListById(1,500,this.eventForm.get('country').value,e)
      }
    } , 400 )
  }


  onSearchCity(e:any){
    clearTimeout(this.cityClearTimeOut)
    this.cityClearTimeOut = setTimeout(() => {
      if(e.length > 0){
      //  this.vm.getCityListById(1,500,this.eventForm.get('state').value,e)
      this.vm.getCityListById(1,500, null, e)
    }

    } , 400 )

  }

  onCitySelect(cityId: any) {
    const selectedCity = this.cityList.find(city => city.id === cityId);
    if (selectedCity) {
    }

//     {
//     "id": 49288,
//     "state_name": "West Bengal",
//     "country_name": "India",
//     "name": "Kolkata",
//     "state": 1669
// }

  }

  // onContryChange() {
  //   this.eventForm.get('country').valueChanges.subscribe( v => {
  //     this.vm.getStateListById(1,500,v)
  //   })
  // }

  // onStateChange() {
  //   this.eventForm.get('state').valueChanges.subscribe( v => {
  //     this.vm.getCityListById(1,500,v)
  //   })
  // }


  onSearchManager(e:any){
     clearTimeout(this.managerSearchTimeOut)
    this.managerSearchTimeOut = setTimeout(() => {
      // const groupId = this.eventForm.get('assigned_group')?.value;
      // if (!groupId) { return; }
      if(e.length > 0){ this.vm.getUserList(1,500,e) }
      } , 400 )
  }

  onSearchMember(e:any){
    clearTimeout(this.userSearchTimeOut)
    this.userSearchTimeOut = setTimeout(() => {
      // const groupId = this.eventForm.get('assigned_group')?.value;
      // if (!groupId) { return; }
      if(e.length > 0){ this.vm.getUserList(1,500,e) }
      } , 400 )
  }

   onEventUrlChange(){
    this.eventForm.get('event_url').valueChanges.pipe(takeUntil(this.destroy$),debounceTime(500)).subscribe(  (v )=> {
      // let photoUrl = '/event/thumbnail?url=' + await this.commonsenseEventsService.getImagePostFeatureImageAsync(v)
      // if(this.eventForm.get('photo').value == null || this.eventForm.get('photo').value?.length == 0){
      if(v != null){
        const urlPattern = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
          if(v.length > 0 && urlPattern.test(v)){
            let photoUrl =   v
            this.loadingImage = true
            this.vm.getEventImage(photoUrl)
          } else {
            this.message.error('Please provide a valid URL', { nzDuration: 1000 });
            this.eventThumbnailNotRecieved()
          }
      }


    })

  }

  eventThumbnailRecieved(e:any){
    this.loadingImage = false
    this.eventImageUrl = this.getBase64Image(e.thumbnail)
    this.eventForm.patchValue({ photo: e.thumbnail })
  }

  eventThumbnailNotRecieved(){
    this.loadingImage = false
    this.eventImageUrl = this.defaultEventImage
    this.eventForm.patchValue({ photo: this.eventImageUrl })
  }

  getBase64Image(data: string){
    if(!data){
      return undefined;
    }
    return "data:image/png;base64," + data;
  }


  onImageChange(event: any): void {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.eventImageUrl = reader.result;
        this.eventForm.patchValue({ photo: this.eventImageUrl.slice(22) });
      };
      reader.readAsDataURL(file);

      // if you track it in the form

    }
  }


closeonly(){
    this.eventForm.reset();
    this.isVisible = false;
    this.closeDrawer.emit(false);
}

close(): void {
    this.isVisible = false;
    this.closeDrawer.emit(false);
    this.quickAddService.refreshData.next(true);
    this.eventForm.reset();
  }

onSearchProject(e: any) {
  const search = (e || '').trim();
  if (search.length === 0) {
    // Keep existing options (especially preloaded project) so it stays visible
    this.loadingProject = false;
    return;
  }
  this.loadingProject = true;
  this.searchInput$.next(search);
}

onSearchIndustry(e: any) {
  const search = (e || '').trim();
  if (search.length === 0) {
    this.listOfIndustries = [];
    this.loadingIndustries = false;
    return;
  }
  this.loadingIndustries = true;
  this.searchInputIndustry$.next(search);
}

onSearchTimezone(e: any) {
  const search = (e || '').trim();
  this.searchInputTimezone$.next(search);
}

getLocationString(): string {
  const locationParts = [];
  try{
     if (this.eventForm.value.city && this.cityList) {
    const city = this.cityList.find(c => c.id === this.eventForm.value.city);
    if (city) locationParts.push(city.name);
    }
    if (this.eventForm.value.state && this.stateList) {
      const state = this.stateList.find(s => s.id === this.eventForm.value.state);
      if (state) locationParts.push(state.name);
    }
    if (this.eventForm.value.country && this.countryList) {
      const country = this.countryList.find(c => c.id === this.eventForm.value.country);
      if (country) locationParts.push(country.name);
    }
  } catch{
  }

  return locationParts.join(', ') || 'Location not specified';
}

getFormattedCountryNames(): string {
  const selectedIds = this.eventForm.value.country;
  if (!selectedIds || !Array.isArray(selectedIds) || selectedIds.length === 0) {
    return '';
  }
  if (!this.countryList) return '';

  const names = this.countryList
    .filter((c: any) => selectedIds.includes(c.id))
    .map((c: any) => c.name);

  return names.join(', ');
}

getEventTypeName(id: number){
  if (!id) return '';

  // First try to find in current eventTypes array
  if (this.eventTypes && this.eventTypes.length > 0) {
    const eventType = this.eventTypes.find(v => v.id === id);
    if (eventType?.name) return eventType.name;
  }

  // If not found in current list (due to filtering), use cached value
  if (this.selectedEventTypeName) {
    return this.selectedEventTypeName;
  }

  return '';
}
getCurrenyName(id: number){
  // Returns the symbol (e.g., $) for display; default to '$' when unknown
  return id && this.currencies != null && this.currencies != undefined && this.currencies.length > 0
    ? this.currencies.filter( v => v.id === id)[0]?.symbol
    : '$';
}

// Returns a combination of symbol and name/code for display (e.g., "$ US Dollar" or "$ USD")
getCurrencyDisplay(id: number): string {
  if (!id || !Array.isArray(this.currencies) || this.currencies.length === 0) {
    return '$ USD';
  }
  const item = this.currencies.find((v: any) => v.id === id);
  if (!item) return '$ USD';
  const symbol = item.symbol || '$';
  const nameOrCode = item.name || item.code || '';
  return nameOrCode ? `${symbol} ${nameOrCode}` : symbol;
}

// Returns the currency name (fallback to code) for a given currency id
getCurrencyName(id: number): string {
  if (!id || !Array.isArray(this.currencies) || this.currencies.length === 0) {
    return 'USD';
  }
  const item = this.currencies.find((v: any) => v.id === id);
  return item?.name || item?.code || 'USD';
}


getCurrencySymbol(currencyCode: string='USD'): string {
  // Robust fallback: if input looks like a symbol (e.g., '$', '₹'), return as-is
  if (!currencyCode) return '$';
  const trimmed = currencyCode.trim();
  if (trimmed.length < 3) return trimmed; // likely a symbol
  try {
    const formatter = new Intl.NumberFormat('en', { style: 'currency', currency: trimmed });
    const parts = formatter.formatToParts(0);
    const symbol = parts.find(part => part.type === 'currency')?.value || '';
    return symbol || '$';
  } catch {
    // If invalid ISO code passed, just return the original (symbol) or default
    return trimmed || '$';
  }
}
getEventStatusName(id: number){
  return id && this.statusList != null && this.statusList != undefined && this.statusList.length > 0 ? this.statusList.filter( v => v.id === id)[0]?.name : ''
}
getProjectName(id: number){
  return id && this.listOfProject != null && this.listOfProject != undefined && this.listOfProject.length > 0 ? this.listOfProject.filter( v => v.id === id)[0]?.name : ''
}

getFormattedDateTime(): string {
  const startdatetimeValue = this.eventForm.value.start_datetime; // Date object
  const enddatetimeValue = this.eventForm.value.end_datetime; // Date object (time portion)

  if (!startdatetimeValue || !enddatetimeValue) return 'Date/time not specified';

  try {
    // Format date with ordinal (20th July, 2025)
    const formattedStartDateTime = this.formatDateWithOrdinal(startdatetimeValue);

    const formattedEndDateTime = this.formatDateWithOrdinal(enddatetimeValue);

    // Format time from Date object to 12-hour format with AM/PM
    // const formattedTime = this.formatTime(timeValue);



    return `${formattedStartDateTime} - ${formattedEndDateTime}`;
  } catch (e) {
    console.error('Error formatting date/time:', e);
    return 'Invalid date/time';
  }
}

private formatDateTime(dateTime: Date){
  const day = dateTime.getDate();
  const month = (dateTime.getMonth()+1).toString().padStart(2, '0');
  const year = dateTime.getFullYear();
  const hours = dateTime.getHours();
  const minutes = dateTime.getMinutes();
  return `${year}-${month}-${day} ${hours}:${minutes}`;
}

private formatDateWithOrdinal(date: Date): string {
  try{


    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();

    // Get ordinal suffix
    let suffix = 'th';
    if (day % 10 === 1 && day !== 11) {
      suffix = 'st';
    } else if (day % 10 === 2 && day !== 12) {
      suffix = 'nd';
    } else if (day % 10 === 3 && day !== 13) {
      suffix = 'rd';
    }

    const hours = date.getHours();
    const minutes = date.getMinutes();

    const ampm = hours >= 12 ? 'PM' : 'AM';
    const displayHour = hours % 12 || 12; // Convert 0 to 12 for 12-hour format
    const paddedMinutes = minutes.toString().padStart(2, '0');

    return `${day}${suffix} ${month}, ${year} ${displayHour}:${paddedMinutes} ${ampm}`;

   }
  catch{
    return null;
  }
}

private formatTime(time: Date): string {
  const hours = time.getHours();
  const minutes = time.getMinutes();

  const ampm = hours >= 12 ? 'PM' : 'AM';
  const displayHour = hours % 12 || 12; // Convert 0 to 12 for 12-hour format
  const paddedMinutes = minutes.toString().padStart(2, '0');

  return `${displayHour}:${paddedMinutes} ${ampm}`;
}


markAllControlsAsTouched(control: any) {
  if (control instanceof FormGroup || control instanceof FormArray) {
    Object.keys(control.controls).forEach(key => {
      this.markAllControlsAsTouched(control.get(key));
    });
  } else {
    control.markAsTouched();
    control.markAsDirty();
  }
}

getFormValidationErrors() {
  let formErrors: any = {};

  Object.keys(this.eventForm.controls).forEach(key => {
    const controlErrors = this.eventForm.get(key)?.errors;
    if (controlErrors) {
      formErrors[key] = controlErrors;
    }
  });

  // Check event_days FormArray errors
  if (this.event_days.errors) {
    formErrors['event_days'] = this.event_days.errors;
  }

  // Check individual event day controls
  this.event_days.controls.forEach((dayGroup: FormGroup, index: number) => {
    Object.keys(dayGroup.controls).forEach(controlKey => {
      const control = dayGroup.get(controlKey);
      if (control?.errors) {
        if (!formErrors['event_days_controls']) {
          formErrors['event_days_controls'] = {};
        }
        formErrors['event_days_controls'][`day_${index}_${controlKey}`] = control.errors;
      }
    });
  });

  return formErrors;
}



  onSubmit() {

    let timeError = false;
    this.event_days.controls.forEach((dayGroup: FormGroup) => {
      const start = dayGroup.get('start_time').value;
      const end = dayGroup.get('end_time').value;
      if (start && end && new Date(end) <= new Date(start)) {
        timeError = true;
      }
    });

    if (timeError) {
      this.message.error('Please ensure all end times are after their start times.');
      return; // Stop submission
    }
    // --- End Custom Validation ---

    // Additional validation for event_days
    let eventDaysValid = true;
    this.event_days.controls.forEach((dayGroup: FormGroup, index: number) => {
      dayGroup.markAllAsTouched();
      if (dayGroup.invalid) {
        eventDaysValid = false;
        Object.keys(dayGroup.controls).forEach(key => {
          const control = dayGroup.get(key);
          if (control?.invalid) {
          }
        });
      }
    });

    // If event-days are valid, derive top-level start/end datetimes so required validators pass
    if (eventDaysValid) {
      const derived = this.deriveStartEndFromEventDays();
      if (derived) {
        // Only patch if not already set
        const currentStart = this.eventForm.get('start_datetime')?.value;
        const currentEnd = this.eventForm.get('end_datetime')?.value;
        if (!currentStart) {
          this.eventForm.get('start_datetime')?.setValue(derived.start);
        }
        if (!currentEnd) {
          this.eventForm.get('end_datetime')?.setValue(derived.end);
        }
        this.eventForm.get('start_datetime')?.updateValueAndValidity({ onlySelf: true });
        this.eventForm.get('end_datetime')?.updateValueAndValidity({ onlySelf: true });
      }
    }


  if(this.eventForm.valid && eventDaysValid){

    this.loadingMsg.next(this.data?.id ? 'Updating Event...' : 'Creating Event...');

    // Ensure duration and duration_name reflect current event_days before sending payload
    const computedDur = this.computeDurationFromEventDays();
    this.eventForm.get('duration')?.setValue(computedDur.id, { emitEvent: false });
    this.eventForm.get('duration_name')?.setValue(computedDur.name, { emitEvent: false });

    const daysData = this.event_days.value.map(day => {
            const date = new Date(day.event_date);
            const startTime = new Date(day.start_time);
            const endTime = new Date(day.end_time);

            const combinedStart = new Date(date.getFullYear(), date.getMonth(), date.getDate(), startTime.getHours(), startTime.getMinutes());
            const combinedEnd = new Date(date.getFullYear(), date.getMonth(), date.getDate(), endTime.getHours(), endTime.getMinutes());

            return {
                day_type: day.day_type,
                event_date: day.event_date,
                start_datetime: this.formatDateTime(combinedStart),
                end_datetime: this.formatDateTime(combinedEnd)
            };
        });

    // New timing array as requested: one item per event day with formatted start/end and order index
    const timing = this.event_days.value.map((day, index: number) => {
      const date = new Date(day.event_date);
      const startTime = new Date(day.start_time);
      const endTime = new Date(day.end_time);

      const combinedStart = new Date(date.getFullYear(), date.getMonth(), date.getDate(), startTime.getHours(), startTime.getMinutes());
      const combinedEnd = new Date(date.getFullYear(), date.getMonth(), date.getDate(), endTime.getHours(), endTime.getMinutes());

      return {
        start_time: this.formatDateTime(combinedStart),
        end_time: this.formatDateTime(combinedEnd),
        order: index,
        day_type: day.day_type
      };
    });

        // Ensure top-level start/end are populated in payload too, prefer derived if available
        const derived = this.deriveStartEndFromEventDays();
        const startDT: Date | null = derived?.start ?? this.eventForm.value.start_datetime ?? null;
        const endDT: Date | null = derived?.end ?? this.eventForm.value.end_datetime ?? null;

        let payload: any = {
          ...this.eventForm.getRawValue(),
          location: this.getLocationString(),
          start_datetime: startDT ? this.formatDateTime(new Date(startDT)) : null,
          end_datetime: endDT ? this.formatDateTime(new Date(endDT)) : null,
          event_days_detail: daysData,
          timing: timing,
          // countryArr: this.eventForm.value.country,
          country : this.eventForm.value.country
          // budget_amount: this.eventForm.value.budget_amount
        };

        // Override duration fields explicitly from computed values to avoid any drift
        payload.duration = computedDur.id;
        payload.duration_name = computedDur.name;

        if (this.data?.id) {
          payload.id = this.data.id;
          if (this.loggedInUser?.id) payload.modified_by = this.loggedInUser.id;
          this.vm.updateEventById(payload,'event-drawer');
        } else {
          if (this.loggedInUser?.id) payload.created_by = this.loggedInUser.id;
          this.vm.createEvent(payload);
        }

      }else {

        this.markAllControlsAsTouched(this.eventForm)
        this.message.error('Please fill all required fields correctly');
        console.warn('Form invalid');
      }



  }

  // Compute the earliest start and latest end across all event_days
  private deriveStartEndFromEventDays(): { start: Date; end: Date } | null {
    if (!this.event_days || this.event_days.length === 0) return null;

    let minStart: Date | null = null;
    let maxEnd: Date | null = null;

    for (const ctrl of this.event_days.controls) {
      const day = ctrl.value;
      if (!day?.event_date || !day?.start_time || !day?.end_time) continue;

      const date = new Date(day.event_date);
      const s = new Date(day.start_time);
      const e = new Date(day.end_time);

      const combinedStart = new Date(date.getFullYear(), date.getMonth(), date.getDate(), s.getHours(), s.getMinutes());
      const combinedEnd = new Date(date.getFullYear(), date.getMonth(), date.getDate(), e.getHours(), e.getMinutes());

      if (!minStart || combinedStart < minStart) minStart = combinedStart;
      if (!maxEnd || combinedEnd > maxEnd) maxEnd = combinedEnd;
    }

    if (minStart && maxEnd) {
      return { start: minStart, end: maxEnd };
    }
    return null;
  }

  eventCreated(e){
    this.loading = false
    this.closeonly()
    setTimeout(() => {
      this.router.navigate(['app/events' , e.id])
    },1000)
  }

  eventUpload(){
    this.loading = false
    this.close()
  }

  private validateStep(step: number): boolean {
    let valid = true;

    // STEP 1 — Event Info
    if (step === 0) {
      const controls = [
        { key: 'event_name', label: 'Event Name' },
        { key: 'event_type', label: 'Event Type' },
        { key: 'status', label: 'Status' },
        { key: 'number_of_attendees', label: 'Number of Attendees' },
        { key: 'event_format', label: 'Event Format' }
      ];

      let firstError: string | null = null;
      controls.forEach(item => {
        const control = this.eventForm.get(item.key);
        control?.markAsTouched();
        control?.markAsDirty();
        if (control?.invalid) {
          valid = false;
          if (!firstError) {
             firstError = `Please enter ${item.label}.`;
          }
        }
      });

      if (!valid && firstError) {
         this.message.error(firstError);
      }
    }

    // STEP 2 — Location + Event Days
    else if (step === 1) {
      const cityControl = this.eventForm.get('city');
      cityControl?.markAsTouched();
      cityControl?.markAsDirty();
      if (cityControl?.invalid) {
         valid = false;
         this.message.error('Please select a City.');
      } else {
          // City valid, check table
          const eventDaysArray = this.event_days;

          if (!eventDaysArray || eventDaysArray.length === 0) {
            valid = false;
            this.message.error('Please add at least one event day.');
          } else {
            let firstErrorMessage: string | null = null;

            eventDaysArray.controls.forEach((dayGroup: FormGroup, index: number) => {
              Object.keys(dayGroup.controls).forEach(key => {
                const ctrl = dayGroup.get(key);
                ctrl?.markAsTouched();
                ctrl?.markAsDirty();
              });

              if (dayGroup.invalid && !firstErrorMessage) {
                if (dayGroup.get('event_date')?.hasError('required')) {
                    firstErrorMessage = `Event Day ${index + 1}: Please select a date.`;
                } else if (dayGroup.get('start_time')?.hasError('required')) {
                    firstErrorMessage = `Event Day ${index + 1}: Please select a start time.`;
                } else if (dayGroup.get('end_time')?.hasError('required')) {
                    firstErrorMessage = `Event Day ${index + 1}: Please select an end time.`;
                } else if (dayGroup.get('day_type')?.hasError('required')) {
                    firstErrorMessage = `Event Day ${index + 1}: Please select a day type.`;
                }
              }
            });

            if (eventDaysArray.invalid || firstErrorMessage) {
              valid = false;
              if (firstErrorMessage) {
                this.message.error(firstErrorMessage);
              } else {
                this.message.error('Please fill all required fields in the event days table.');
              }
            }
          }
      }
    }

    // STEP 3 — Budget
    else if (step === 2) {
      const controls = [
        { key: 'budget_type', label: 'Budget Type' },
        { key: 'budget_currency_type', label: 'Currency' }
      ];

      let firstError: string | null = null;
      controls.forEach(item => {
        const control = this.eventForm.get(item.key);
        control?.markAsTouched();
        control?.markAsDirty();
        if (control?.invalid) {
            valid = false;
            if(!firstError) {
                firstError = `Please select ${item.label}.`;
            }
        }
      });

      if(!valid && firstError) {
          this.message.error(firstError);
      }
    }

    return valid;
  }


  onIndexChange(index: number): void {
    // Allow backward navigation freely, but validate all previous steps before going forward
    if (index < this.stepIndex) {
      // Going backward - allow freely
      this.stepIndex = index;
    } else if (index > this.stepIndex) {
      // Going forward - validate all steps from current to the target step
      let canNavigate = true;
      for (let step = this.stepIndex; step < index; step++) {
        if (!this.validateStep(step)) {
          canNavigate = false;
          break;
        }
      }
      
      if (canNavigate) {
        this.stepIndex = index;
      }
    }

    if (this.stepIndex === 2) {
      this.onCurrencyChange(this.eventForm.get('budget_currency_type')?.value);
    }
  }

  nextStep() {
    // Validate current step before allowing progression to next step via Next button
    if (this.validateStep(this.stepIndex)) {
      // Update step directly without validation (onIndexChange now allows free navigation)
      if (this.stepIndex + 1 < 4) {
        this.stepIndex = this.stepIndex + 1;
        
        // Handle currency change for Budget step
        if (this.stepIndex === 2) {
          this.onCurrencyChange(this.eventForm.get('budget_currency_type')?.value);
        }
      }
    }
  }



  loadingConversion:boolean = false;
  fetchConvertion(e:any){
    e.preventDefault();
    if(this.eventForm.get('budget_currency_type').value){
       this.loadingConversion = true
       this.vm.getconvertedCurrency(this.eventForm.get('budget_currency_type').value, '2', 'event-drawer')
    }
  }

  onCurrencyChange(e:any){
    this.vm.getconvertedCurrency(e, '2', 'event-drawer')
  }


  convertedCurrencyRecieved(e:any){
    if(e.rate){
      this.eventForm.get('usd_currency_exchange_rate').setValue(e.rate.toFixed(4))

      if(this.eventForm.get('budget_currency_amount').value){
        // this.eventForm.get('budget_amount').setValue(this.eventForm.get('budget_currency_amount').value * e.rate)
        this.eventForm.get('budget_amount').setValue(this.truncate(this.eventForm.get('budget_currency_amount').value * e.rate, 2));
      }
      this.loadingConversion = false
    }
  }

  calculateAmount(e: any){
    if(e && this.eventForm.get('usd_currency_exchange_rate').value){
      let result = e * this.eventForm.get('usd_currency_exchange_rate').value
      // this.eventForm.get('budget_amount').setValue(e * this.eventForm.get('usd_currency_exchange_rate').value)
      this.eventForm.get('budget_amount').setValue(this.truncate(result,2))

    } else {
      this.eventForm.get('budget_amount').setValue(0)
    }
  }

  blockDecimalInput(event: KeyboardEvent){
    if(['.', 'e', 'E', '+', '-'].includes(event.key)){
      event.preventDefault();
    }
  }

  sanitizeAttendeesInput(event: Event){
    const input = event.target as HTMLInputElement;
    const sanitizedValue = input.value.replace(/[^0-9]/g, '');
    if(input.value !== sanitizedValue){
      input.value = sanitizedValue;
      this.eventForm.get('number_of_attendees')?.setValue(sanitizedValue ? Number(sanitizedValue) : '', { emitEvent: false });
    }
  }

   truncate(number: number, decimals: number): number {
      const powerOfTen = Math.pow(10, decimals);
      return Math.floor(number * powerOfTen) / powerOfTen;
  }

  maxEndDate: Date = new Date(new Date().setFullYear(this.today.getFullYear() + 1));

  get event_days(): FormArray {
    return this.eventForm.get('event_days') as FormArray;
  }

  // Parse 'YYYY-MM-DD HH:mm' or ISO-like strings into a local Date (no timezone shift)
  private parseTimingToLocalDate(dt: string): Date | null {
    if (!dt || typeof dt !== 'string') return null;
    // Normalize space or T separator
    const m = dt.trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{1,2}):(\d{1,2})(?::(\d{1,2}))?$/);
    if (m) {
      const year = Number(m[1]);
      const monthIdx = Number(m[2]) - 1;
      const day = Number(m[3]);
      const hour = Number(m[4]);
      const minute = Number(m[5]);
      const second = m[6] ? Number(m[6]) : 0;
      return new Date(year, monthIdx, day, hour, minute, second);
    }
    // Try native parse as a last resort
    const parsed = new Date(dt);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  // Map selected format to flags and fetch filtered event types
  private loadEventTypesForFormatById(formatId: number) {
    // Try to determine in-person/virtual by looking up name in eventFormats
    const fmt = Array.isArray(this.eventFormats) ? this.eventFormats.find((f: any) => f?.id === formatId) : undefined;
    const name: string = (fmt?.name || '').toLowerCase();
    let isInPerson = name.includes('in') && name.includes('person');
    let isVirtual = name.includes('virtual');

    // If names are not available (e.g., ids only), fall back to common id mapping if provided via backend (assumption minimal)
    const opts: { is_inperson?: boolean; is_virtual?: boolean } = {};
    if (!fmt || (!isInPerson && !isVirtual)) {
      // Fallback by conventional IDs: 1 = In-Person, 2 = Virtual, else Hybrid
      if (formatId === 1) { isInPerson = true; }
      else if (formatId === 2) { isVirtual = true; }
    }

    if (isInPerson) {
      opts.is_inperson = true;
    } else if (isVirtual) {
      opts.is_virtual = true;
    } else {
      // Hybrid or unknown → no flags
    }

    this.vm.getEventTypeListFiltered(1, 500, opts);
  }


  // Date selection rule: allow today and future dates; disallow past dates for all modes
  // Also prevent selecting already chosen dates in Multi-day mode
  disabledDate = (current: Date, rowIndex?: number): boolean => {
    if (!current) return false;

    // Disable past dates
    if (differenceInCalendarDays(current, this.today) < 0) {
      return true;
    }

    // For Multi-day mode, disable already selected dates (except the current row's date)
    const durationId = this.eventForm?.get('duration')?.value;
    if (durationId === 3 && this.event_days && this.event_days.controls) {
      const isDateAlreadySelected = this.event_days.controls.some((ctrl: FormGroup, idx: number) => {
        // Skip the current row being edited
        if (rowIndex !== undefined && idx === rowIndex) {
          return false;
        }

        const selectedDate = ctrl.get('event_date')?.value;
        if (!selectedDate) return false;

        // Check if the current date matches any already selected date
        return differenceInCalendarDays(new Date(selectedDate), current) === 0;
      });

      if (isDateAlreadySelected) {
        return true;
      }
    }

    return false;
  };

  // Helper method to create a disabledDate function for a specific row index
  getDisabledDateForRow(rowIndex: number): (current: Date) => boolean {

    return (current: Date) => {
      // Always disallow past dates

      if (!current || differenceInCalendarDays(current, this.today) < 0) {
        return true;
      }

      const durationId = this.eventForm?.get('duration')?.value;

      if (durationId === 3 && this.event_days && this.event_days.controls) {
        if (rowIndex > 0) {

          // For Day N (N>1): only allow dates strictly after Day N-1
          const prevCtrl = this.event_days.controls[rowIndex - 1];
          const prevDate = prevCtrl.get('event_date')?.value;
          if (prevDate) {
            // Disallow current <= prevDate (must be strictly after)
            if (differenceInCalendarDays(current, new Date(prevDate)) <= 0) {
              return true;
            }
          }
          // Do NOT check for duplicate dates for N>1, as strictly increasing order prevents duplicates
        } else if (rowIndex === 0) {

          // For Day 1, disallow any date already used by other days (except current)
          for (let idx = 1; idx < this.event_days.controls.length; idx++) {
            const selectedDate = this.event_days.controls[idx].get('event_date')?.value;
            if (selectedDate && differenceInCalendarDays(new Date(selectedDate), current) === 0) {
              return true;
            }
          }
        }
      }
      return false;
    };
  }

  useDateOnly : boolean = false

   // Disabled time function
  disabledDateTime: DisabledTimeFn = (current: Date) => {
    if (!current) return { nzDisabledHours: () => [], nzDisabledMinutes: () => [], nzDisabledSeconds: () => [] };

    const now = new Date();

    // If current date is today → disable past hours/minutes/seconds
    if (current.toDateString() === now.toDateString()) {
      return {
        nzDisabledHours: () => this.range(0, now.getHours()),
        nzDisabledMinutes: () =>
          current.getHours() === now.getHours() ? this.range(0, now.getMinutes()) : [],
        nzDisabledSeconds: () =>
          current.getHours() === now.getHours() && current.getMinutes() === now.getMinutes()
            ? this.range(0, now.getSeconds())
            : []
      };
    }
     // For other dates → allow all
    return { nzDisabledHours: () => [], nzDisabledMinutes: () => [], nzDisabledSeconds: () => [] };
  };



  validateDates() {
      const start = this.eventForm.get('start_datetime')?.value;
      const end = this.eventForm.get('end_datetime')?.value;

      // Read duration id to apply rules
      const duration = this.eventForm.get('duration')?.value;

      if (start && end) {
        const startDate = new Date(start);
        const endDate = new Date(end);

        // 1. General check: End date cannot be before start date.
        if (startDate > endDate) {
          this.message.error('Start date cannot be after End date', { nzDuration: 2500 });
          this.eventForm.get('end_datetime')?.setValue(null);
          return; // Stop further validation
        }

        // 2. Rule: For "Multi-day" (ID 3), dates cannot be the same.
        if (duration === 3 && startDate.toDateString() === endDate.toDateString()) {
          this.message.error('For a Multi-day event, the end date must be after the start date.', { nzDuration: 2500 });
          this.eventForm.get('end_datetime')?.setValue(null); // Reset the invalid date
        }
      }
  }

  // MODIFIED: This is the new structure for each row in the FormArray
  createEventDayGroup(): FormGroup {

    return this.fb.group({
      event_date: [null, [Validators.required]],
      start_time: [null, [Validators.required]], // Reverted
      end_time: [null, [Validators.required]],   // Reverted
      day_type: ['full', [Validators.required]]
    });
  }

  // Helpers to preserve and restore event_days across format switches
  private cloneEventDayValue(value: any): any {
    if (!value) return null;
    return {
      event_date: value.event_date ? new Date(value.event_date) : null,
      start_time: value.start_time ? new Date(value.start_time) : null,
      end_time: value.end_time ? new Date(value.end_time) : null,
      day_type: value.day_type ?? 'full'
    };
  }

  private getClonedEventDays(): any[] {
    return this.event_days.controls.map((ctrl: FormGroup) => this.cloneEventDayValue(ctrl.value));
  }

  private setEventDaysFromList(list: any[]): void {
    this.event_days.clear();
    if (!Array.isArray(list) || list.length === 0) {
      const g = this.createEventDayGroup();
      this.event_days.push(g);
      this.attachEventDayWatchers(g);
      return;
    }
    list.forEach(v => {
      const g = this.createEventDayGroup();
      g.patchValue({
        event_date: v?.event_date ? new Date(v.event_date) : null,
        start_time: v?.start_time ? new Date(v.start_time) : null,
        end_time: v?.end_time ? new Date(v.end_time) : null,
        day_type: v?.day_type ?? 'full'
      });
      this.event_days.push(g);
      this.attachEventDayWatchers(g);
    });
  }

  private saveCurrentDaysToCache(formatId: number): void {
    if (formatId == null) return;
    const cloned = this.getClonedEventDays();
    this.eventDaysCache[formatId] = cloned;
  }

  private restoreDaysFromCacheOrDefault(durationId: number): void {
    const cached = this.eventDaysCache[durationId];
    if (Array.isArray(cached) && cached.length > 0) {
      if (durationId === 1 || durationId === 2) {
        // Half-day or Single-day: enforce a single row and adjust day_type accordingly
        const first = this.cloneEventDayValue(cached[0]);
        first.day_type = durationId === 1 ? 'half' : 'full';
        this.setEventDaysFromList([first]);
      } else {
        // Multi-day: restore all rows
        this.setEventDaysFromList(cached);
      }
      return;
    }

    // No cache for this format: build sensible defaults
    this.event_days.clear();
    if (durationId === 1 || durationId === 2) {
      const g = this.createEventDayGroup();
      g.patchValue({ day_type: durationId === 1 ? 'half' : 'full' });
      this.event_days.push(g);
    } else {
      // Multi-day default: start with a single full-day row
      this.event_days.push(this.createEventDayGroup());
    }
  }

  // NEW FUNCTIONS to manage the FormArray
  addEventDay(): void {
    const group = this.createEventDayGroup();
    this.event_days.push(group);
    this.attachEventDayWatchers(group);
  }

  removeEventDay(index: number): void {
    if (this.event_days.length > 1) {
      this.event_days.removeAt(index);
    }
  }

  // Enable Create/Update only when all required fields are satisfied,
  // ignoring top-level start/end which are derived from event_days on submit.
  get canSubmit(): boolean {
    if (!this.eventForm) return false;
    // Check all top-level controls except start/end
    const controls = this.eventForm.controls as { [key: string]: any };
    for (const key of Object.keys(controls)) {
      if (key === 'start_datetime' || key === 'end_datetime') continue;
      const ctrl = controls[key];
      if (ctrl && ctrl.invalid) return false;
    }
    // Check event_days array and each group
    if (!this.event_days || this.event_days.invalid) return false;
    for (const group of this.event_days.controls as FormGroup[]) {
      if (group.invalid) return false;
    }
    return true;
  }

  // ----- Row-level watchers and validators for dates/times (end after start, no duplicate dates) -----
  attachEventDayWatchers(group: FormGroup): void {
    if (!group) return;
    // Watch date changes to block duplicates in multi-day
    group.get('event_date')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((val: Date) => {
      if (!val) return;
      this.checkDuplicateEventDate(group);
    });

    // Watch time changes to ensure end > start
    const startCtrl = group.get('start_time');
    const endCtrl = group.get('end_time');
    startCtrl?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.validateRowTimes(group);
      this.enforceEndTimeConstraints(group);
    });
    endCtrl?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.validateRowTimes(group);
      this.enforceEndTimeConstraints(group);
    });

    // Watch day type changes in multi-day to (re)apply constraints
    group.get('day_type')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.enforceEndTimeConstraints(group);
    });
  }

  validateRowTimes(group: FormGroup): void {
    const start: Date | null = group.get('start_time')?.value ? new Date(group.get('start_time')?.value) : null;
    const end: Date | null = group.get('end_time')?.value ? new Date(group.get('end_time')?.value) : null;
    if (start && end) {
      if (end <= start) {
        // Assumption: End time must be after start time (common rule)
        this.message.warning('End time must be after start time.');
        group.get('end_time')?.setValue(null);
      }
    }
  }

  checkDuplicateEventDate(group: FormGroup): void {
    // Only enforce duplicates when Multi-day duration is selected
    const durationId = this.eventForm?.get('duration')?.value;
    if (durationId !== 3) return;

    const currentDate: Date | null = group.get('event_date')?.value ? new Date(group.get('event_date')?.value) : null;
    if (!currentDate) return;

    const currentIdx = this.event_days.controls.indexOf(group);
    const isDuplicate = this.event_days.controls.some((ctrl: FormGroup, idx: number) => {
      if (idx === currentIdx) return false;
      const d = ctrl.get('event_date')?.value ? new Date(ctrl.get('event_date')?.value) : null;
      return d ? differenceInCalendarDays(d, currentDate) === 0 : false;
    });

    if (isDuplicate) {
      this.message.warning('This date is already added. Please select a different date.');
      group.get('event_date')?.setValue(null, { emitEvent: false });
    }
  }

  // Enforce half-day constraint: end_time <= start_time + 12 hours for applicable modes
  private enforceEndTimeConstraints(group: FormGroup): void {
    const start: Date | null = group.get('start_time')?.value ? new Date(group.get('start_time')?.value) : null;
    const end: Date | null = group.get('end_time')?.value ? new Date(group.get('end_time')?.value) : null;
    if (!start) return;

    const cap = this.getMaxEndTimeForGroup(group, start);
    if (!cap) return;

    if (end && end > cap) {
      // Clamp end to the cap and inform gently
      group.get('end_time')?.setValue(cap);
      this.message.info('End time capped to 12 hours after start for Half Day.');
    }
  }

  private getMaxEndTimeForGroup(group: FormGroup, start: Date): Date | null {
    try {
      const mode = this.eventForm?.get('duration')?.value; // 1=Half,2=Single,3=Multi
      const dayType = (group.get('day_type')?.value || '').toString().toLowerCase();
      const halfDayActive = mode === 1 || (mode === 3 && (dayType === 'half' || dayType === 'roundtable'));
      if (!halfDayActive) return null;
      const cap = new Date(start);
      cap.setHours(cap.getHours() + 12);
      return cap;
    } catch {
      return null;
    }
  }

  // Map duration id to readable name
  private getDurationNameById(id: number): string {
    switch (id) {
      case 1: return 'Half Day';
      case 2: return 'Single Day';
      case 3: return 'Multi Day';
      default: return 'Single Day';
    }
  }

  // Infer duration by inspecting event_days: >1 rows => Multi Day; 1 row => Half/Single based on day_type
  private computeDurationFromEventDays(): { id: number; name: string } {
    const days = this.event_days?.value || [];
    if (Array.isArray(days) && days.length > 1) {
      return { id: 3, name: this.getDurationNameById(3) };
    }
    if (Array.isArray(days) && days.length === 1) {
      const t = (days[0]?.day_type || '').toString().toLowerCase();
      if (t === 'half' || t === 'roundtable') return { id: 1, name: this.getDurationNameById(1) };
      return { id: 2, name: this.getDurationNameById(2) };
    }
    // Fallback to current control value
    const cur = this.eventForm?.get('duration')?.value ?? 2;
    return { id: cur, name: this.getDurationNameById(cur) };
  }


//   {
//     "id": 49288,
//     "state_name": "West Bengal",
//     "country_name": "India",
//     "name": "Kolkata",
//     "state": 1669
// }


  ensureArray(value: any): any[] {
    if (value === null || value === undefined) return [];
    if (Array.isArray(value)) return value;
    return [value];
  }

    // ── External Moderators (Drawer) ────────────────────────────────────

    loadAllModeratorsForDrawer(): void {
      this.moderatorService.getAllModerators(1, 300).subscribe({
        next: (data: any) => {
          this.allModerators = data?.results ?? (Array.isArray(data) ? data : []);
        }
      });
    }

    openModeratorModalForDrawer(): void {
      this.editingModeratorForDrawer = null;
      this.moderatorModalVisible = true;
    }

    closeModeratorModalForDrawer(): void {
      this.moderatorModalVisible = false;
      this.editingModeratorForDrawer = null;
    }

    onModeratorSaveForDrawer(formValue: any): void {
      this.moderatorSaving = true;

      if (formValue?.mode === 'existing' && formValue?.existing_moderator_id) {
        const existingId = Number(formValue.existing_moderator_id);
        const current: number[] = [...(this.eventForm.get('event_moderators')?.value || [])];
        if (!current.includes(existingId)) {
          this.eventForm.get('event_moderators')?.setValue([...current, existingId]);
        }
        this.moderatorSaving = false;
        this.closeModeratorModalForDrawer();
        return;
      }

      const payload = {
        name: formValue?.name,
        company: formValue?.company,
        job_title: formValue?.job_title,
        email: formValue?.email,
        phone_number: formValue?.phone_number,
        linkedin_url: formValue?.linkedin_url,
        created_by: this.loggedInUser?.id
      };

      this.moderatorService.createModerator(payload).subscribe({
        next: (created: any) => {
          this.allModerators = [...this.allModerators, created];
          const current: number[] = [...(this.eventForm.get('event_moderators')?.value || [])];
          this.eventForm.get('event_moderators')?.setValue([...current, created.id]);
          this.message.success('Moderator created and selected');
          this.moderatorSaving = false;
          this.closeModeratorModalForDrawer();
        },
        error: () => {
          this.message.error('Failed to create moderator');
          this.moderatorSaving = false;
        }
      });
    }
}

